module.exports = __webpack_public_path__ + "static/media/purple.86630d3b.jpg";